module.exports = __webpack_public_path__ + "65d4d53a692ad0a4fa4ffec2124e6887.png";